import React from 'react';
import { useModalManager } from 'components/common/Modal';
import { TCITooltip } from '@/components/ui/Tooltip';
import AsyncAssignmentModal from 'components/staffer/AssignmentModal/AsyncAssignmentModal';
import I18n from 'modules/i18n';
import AssignmentMadeTooltipContent from '@/components/common/AssignmentMadeTooltipContent';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';
import styles from './index.module.scss';

export type InitialAssignableType = {
  modelType: string,
  modelsToAssign: string | string[] | { label: string, value: string }[],
  slideShowSelect?: string,
};

export interface AssignButtonProps {
  children?: ReactChildren;
  circle?: boolean;
  className?: string;
  handlePostSave?: Function,
  initialIsUnit?: boolean,
  initialValues: InitialAssignableType,
  isAssigned: boolean,
  iconSize?: number,
  lessonId?: number,
  program?: { id: number },
  stafferId?: number,
}

const AssignButton = ({
  children = null,
  circle = false,
  className,
  handlePostSave = () => {},
  initialIsUnit = false,
  initialValues,
  isAssigned,
  lessonId,
  program,
  iconSize = 20,
  stafferId,
}: AssignButtonProps) => {
  const modalManager = useModalManager();
  const assignmentCreatedMessage = `${I18n.t('assignment_already_created')} ${I18n.t('go_to_assignments_to_review')}`;

  return (
    <>
      <TCITooltip sideOffset={15}>
        <TCITooltip.Trigger asChild>
          <button
            aria-haspopup="dialog"
            aria-label={`${I18n.t('create_assignment')}. ${isAssigned ? assignmentCreatedMessage : ''}`}
            className={cn(
              'tw-border tw-border-solid tw-border-light-grey tw-p-1 tw-box-border tw-cursor-pointer', {
                [styles.iconCircle]: circle,
                [styles.iconLink]: !circle,
              },
              className,
            )}
            type="button"
            onClick={modalManager.open}
          >
            {children}
            {!children && (
              <>
                <Icon
                  className={cn(
                    { 'tw-text-green': isAssigned },
                    { 'tw-text-inherit hover:tw-text-tci-purple': !isAssigned },
                  )}
                  icon={isAssigned ? 'Assigned' : 'Assign'}
                  size={iconSize}
                />
                <span className="sr-only">{I18n.t('create_assignment')}</span>
              </>
            )}
          </button>
        </TCITooltip.Trigger>
        <TCITooltip.Content>
          {isAssigned ? <AssignmentMadeTooltipContent /> : I18n.t('create_assignment')}
        </TCITooltip.Content>
      </TCITooltip>

      <AsyncAssignmentModal
        closeModal={modalManager.close}
        handlePostSave={handlePostSave}
        initialIsUnit={initialIsUnit}
        initialLessonId={lessonId}
        initialValues={initialValues}
        modalIsOpen={modalManager.isOpen}
        program={program}
        stafferId={stafferId}
      />
    </>
  );
};

export default AssignButton;
